import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Trash } from "@phosphor-icons/react";
import { CampaignEditor } from "./campaign/CampaignEditor";
import { LeadTemplates } from "./campaign/LeadTemplates";
import { ST, FU_ST } from "./campaign/CampaignParts";

export default function LeadCampaigns({ openId, setOpenId }) {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/leads/campaigns").then(({ data }) => setList(data.campaigns)).catch(() => {});
  useEffect(() => { if (!openId) load(); }, [openId]);
  if (openId) return <CampaignEditor id={openId} onBack={() => setOpenId(null)} onOpen={setOpenId} />;
  const del = async (id) => {
    if (!window.confirm("Supprimer ce brouillon de campagne ?")) return;
    try { await api.delete(`/admin/leads/campaigns/${id}`); load(); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  return (
    <div className="space-y-4">
      <div className="surface rounded-lg p-5" data-testid="lead-campaigns">
        <div className="overline mb-3">Campagnes de prospection</div>
        <p className="text-xs text-muted mb-4">Sélectionnez des prospects dans l'onglet Prospects puis « Préparer une campagne ». Aucun email n'est envoyé sans votre validation explicite.</p>
        {!list.length && <p className="text-sm text-muted" data-testid="lead-campaigns-empty">Aucune campagne.</p>}
        {list.map((c) => (
          <div key={c.id} className="flex items-center justify-between gap-2 border-b border-border/50 py-2 text-sm" data-testid={`lead-campaign-${c.id}`}>
            <button onClick={() => setOpenId(c.id)} className="text-fg hover:text-accent text-left min-w-0">{c.name} <span className="text-xs text-muted">· {c.sirens.length} entreprise(s) · {ST[c.status]}{c.status === "sent" ? ` · ${c.sent} envoyé(s), ${c.failed} échec(s) · ${c.stats?.opened || 0} ouvert(s), ${c.stats?.clicked || 0} clic(s) · ${c.stats?.replied || 0} réponse(s), ${c.stats?.interested || 0} intéressé(s), ${c.stats?.converted || 0} converti(s)` : ""}{c.followup ? ` · relance ${FU_ST[c.followup.status] || ""}` : ""}</span></button>
            {c.status === "draft" && <button onClick={() => del(c.id)} className="text-muted hover:text-destructive shrink-0" data-testid={`lead-campaign-delete-${c.id}`}><Trash size={14} /></button>}
          </div>
        ))}
      </div>
      <LeadTemplates />
    </div>
  );
}
